import { DatadogIconUrl } from "@p0security/shared/integrations/constants";
import { DatadogComponents } from "@p0security/shared/integrations/event-collectors/datadog/components";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { Logo } from "../Logo";
import { datadogInstaller } from "./install";

export const DatadogIcon = (
  <Logo logo={DatadogIconUrl} title="Datadog" size={14} />
);
export const Datadog = (
  props: Pick<
    InstallProps<typeof DatadogComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "endpoint", []);
  return (
    <Install<typeof DatadogComponents>
      components={DatadogComponents}
      installer={datadogInstaller}
      integration="datadog"
      itemKind={itemKind}
      logo={DatadogIconUrl}
      title={"Datadog"}
      {...props}
    />
  );
};
